import UtilService from "../services/util.service";

export default {
  name: "formatStage",
  fn: (claimStage, claim) => {
    return UtilService.formatStage(claimStage, claim);
  }
};
